import classNames from 'classnames';
import Logo from '@/components/atoms/logo/logo';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import { ModuleWrapperProps } from '@/components/utilities/module-wrapper/module-wrapper';
import { usePageDetailsContext } from '@/libraries/contexts/page-details-context/page-details-context';
import { getLogoName } from '@/libraries/getters/get-logo-name';
import styles from './error-message.module.scss';

export interface ErrorMessageProps extends ModuleWrapperProps {
  /** The class name to apply */
  className?: string;
  /** The text to show as a headline */
  headline?: string | null;
  /** The rich text to show as a description */
  text?: string | null;
}

const ErrorMessage = ({ className, headline, text }: ErrorMessageProps) => {
  const { brand } = usePageDetailsContext();

  return (
    <div className={classNames(styles.component, className)}>
      <Logo
        className={styles.errorIcon}
        name={getLogoName({
          brand: brand,
          type: 'NoResults',
        })}
      />

      <div className={styles.errorContent}>
        {headline && (
          <Typography
            className={styles.errorHeading}
            tag="h2"
            tagStyle="headingMedium"
          >
            {headline}
          </Typography>
        )}

        {text && <RichText className={styles.errorText} text={text} />}
      </div>
    </div>
  );
};

ErrorMessage.displayName = 'ErrorMessage';

export default ErrorMessage;
